import styles from "./Submission.module.scss";

const Submission = () => {
    return (
        <div className={styles["note-wrapper"]}>
            <div className={styles["note-section"]}>
                <div className={styles["heading"]}>Note:</div>
                <p>
                    Campaign stock will be reserved and unavailable for sale until the
                    campaign starts.
                </p>
                <p className="fw-medium">Confirm your submission</p>
                <div className={styles["buttons"]}>
                    <div className={styles["done-btn"]}>Done</div>
                    <div className={styles["cancel-btn"]}>Cancel</div>
                </div>
            </div>
        </div>
    );
};

export default Submission;